import React from 'react';
import { connect } from 'react-redux';
import { clearListMessage } from '../../store/lists/actions';

import SchoolCode from 'Containers/SchoolCode';
import ListPageHeader from 'Components/ListPageHeader';

class UsersPageHeader extends React.PureComponent {
  componentDidUpdate(prevProps) {
    // If a new message is set, clear it after 5 seconds.
    // This assumes all messages are set to fade out.

    if (
      this.props.message !== null &&
      this.props.message.type === 'success' &&
      this.props.message !== prevProps.message
    ) {
      window.setTimeout(
        this.props.clearListMessage,
        5000,
        this.props.activeTab
      );
    }
  }

  render() {
    const {
      activeSchool,
      activeTab,
      handleTabClick,
      message,
      tabSwitcher,
      listTableHeader,
    } = this.props;
    return (
      <ListPageHeader
        pageTitle={activeSchool.name}
        headerActionButton={<SchoolCode />}
        listType={activeTab}
        handleTabClick={handleTabClick}
        tabSwitcher={tabSwitcher}
        message={message}
        listTableHeader={listTableHeader}
      />
    );
  }
}

export default connect(false, { clearListMessage })(UsersPageHeader);
